import { React, useEffect, useState } from "react";
import FormAccordion from "../../../components/Form/FormAccordion";
import { DatePicker } from "antd";
import { SelectField } from "../../../components/Form/FormComponents";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
	fetchAllCategories,
	fetchSubCategories,
	fetchBrands,
	fetchModels,
} from "../../Products/ProductUtils/CategoriesUtils";
import { CustomSelectField } from "./FormComponents";
import { toast } from "react-toastify";
import { setFilteredData } from "../LeaseSlice";
import { colorList } from "../../../assets/data/colors";

/* eslint-disable react/prop-types */

const CreateProductInfo = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [categories, setCategories] = useState([]);
	const [formData, setFormData] = useState({});
	const [subCategoryOptions, setSubCategoryOptions] = useState([]);
	const [brandOptions, setBrandOptions] = useState([]);
	const [modelOptions, setModelOptions] = useState([]);

	useEffect(() => {
		getCategories();
	}, []);

	const getCategories = async () => {
		try {
			const categories = await fetchAllCategories();
			if (categories.length > 0) {
				setCategories(categories);
			} else {
				setCategories([]);
				console.log("No categories found");
				toast.error("No categories found");
			}
		} catch (error) {
			console.log(error);
			toast.error("No categories found");
		}
	};

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const getSubCategories = async (e) => {
		setFormData({
			...formData,
			brand: "",
			model: "",
			subCategory: "",
			[e.target.name]: e.target.value,
		});
		setBrandOptions([]);
		setModelOptions([]);
		try {
			const subCategory = await fetchSubCategories(e.target.value);
			if (subCategory[0].name === "" || subCategory.length <= 0) {
				setSubCategoryOptions([]);
				toast.error("No sub categories found");
			} else {
				setSubCategoryOptions(subCategory);
			}
		} catch (error) {
			toast.error("No sub categories found");
			setSubCategoryOptions([]);
		}
	};

	const getBrands = async (e) => {
		const selectedSubCategory = subCategoryOptions.find((item) => item.name === e.target.value);
		try {
			const brands = await fetchBrands(selectedSubCategory.id);
			console.log(brands);
			if (brands.length > 0) {
				setFormData({
					...formData,
					[e.target.name]: selectedSubCategory.name,
					brand: "",
					model: "",
				});
				// console.log(brands);
				const modifiedBrands = brands.map(({ name, catId }) => ({
					name,
					id: catId,
				}));
				setBrandOptions(modifiedBrands);
			} else {
				setFormData({
					...formData,
					[e.target.name]: selectedSubCategory.name,
					brand: "",
					model: "",
				});
				setBrandOptions([]);
				toast.error("No brands found");
			}
		} catch (error) {
			console.log(error);
			setBrandOptions([]);
			toast.error("No brands found");
		}
	};

	const getModel = async (e) => {
		const selectedBrand = brandOptions.find((item) => item.name === e.target.value);
		try {
			const model = await fetchModels(selectedBrand.name, selectedBrand.id);
			if (model.length <= 0 || model[0].name === "") {
				setModelOptions([]);
				toast.error("No model found");
			} else {
				setFormData({ ...formData, brand: selectedBrand.name, model: "" });
				setModelOptions(model);
			}
		} catch (error) {
			console.log(error);
			setModelOptions([]);
		}
	};

	const handleYear = (date, dateString) => {
		setFormData({ ...formData, year: dateString });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(formData);
		dispatch(
			setFilteredData({
				subCategory: formData?.subCategory,
				brand: formData?.brand,
			})
		);
		// Navigate to next tab
		navigate("/lease/create_asset/product_catalog");
	};

	return (
		<StyledForm className='mt-0' onSubmit={handleSubmit}>
			<div className='w-full'>
				<FormAccordion title='Create Lease' open={true}>
					<div className='grid grid-cols-2 gap-4'>
						<div className='form-group'>
							<label>PRODUCT CATEGORY</label>
							<CustomSelectField
								name='category'
								handleChange={getSubCategories}
								isEditable={true}
								options={categories}
								value={formData?.category}
								required={true}
							/>
						</div>

						<div className='form-group'>
							<label>SUB CATEGORY</label>
							<CustomSelectField
								name='subCategory'
								handleChange={getBrands}
								isEditable={true}
								options={subCategoryOptions}
								value={formData?.subCategory || ""}
							/>
						</div>

						<div className='form-group'>
							<label>BRAND</label>
							<CustomSelectField
								name='brand'
								handleChange={getModel}
								isEditable={true}
								value={formData?.brand || ""}
								options={brandOptions}
								required={true}
							/>
						</div>

						<div className='form-group'>
							<label>MODEL</label>
							<CustomSelectField
								name='model'
								handleChange={handleInputChange}
								isEditable={true}
								value={formData?.model || ""}
								options={modelOptions}
								required={true}
							/>
						</div>

						<div className='form-group'>
							<label>COLOR</label>
							<SelectField
								name='color'
								handleChange={handleInputChange}
								isEditable={true}
								value={formData?.color}
								required={true}
								options={colorList}
							/>
						</div>

						<div className='form-group'>
							<label>YEAR</label>
							<DatePicker
								style={{ padding: "0.7rem", border: "1px solid #b8c8cf" }}
								onChange={handleYear}
								picker='year'
							/>
						</div>
					</div>

					<Button variant='contained' color='primary' type='submit' sx={{ mt: 4, px: 5 }}>
						Proceed
					</Button>
				</FormAccordion>
			</div>
		</StyledForm>
	);
};

export default CreateProductInfo;
